import { ActivityType } from 'modules/trainingLibrary/TrainingLibrary/types'

const routes = {
  root: `/${ActivityType.Surveys}`,
}

export default routes
